import { Box, Stack, Typography, useTheme } from "@mui/material";
import { Volleyball } from "./Icons";

// Branded header above every screen: a court-line volleyball mark and the
// wordmark, flat and squared to match the court-lines identity.
export const Hero = ({ tagline }: { tagline?: string }) => {
  const theme = useTheme();
  return (
    <Stack alignItems="center" spacing={1.2} sx={{ pt: 5, pb: 1 }}>
      <Box
        sx={{
          width: 58,
          height: 58,
          borderRadius: "12px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "primary.main",
          border: `2px solid ${theme.palette.primary.main}`,
        }}
      >
        <Volleyball width={30} height={30} />
      </Box>
      <Typography
        variant="h4"
        sx={{
          textTransform: "uppercase",
          letterSpacing: "0.04em",
          color: "primary.main",
          fontWeight: 800,
        }}
      >
        VoloPilot
      </Typography>
      {tagline && (
        <Typography variant="body1" color="text.secondary" align="center">
          {tagline}
        </Typography>
      )}
    </Stack>
  );
};
